(() => {
  if (window.__AVPDPPortfolioV35) return;
  window.__AVPDPPortfolioV35 = true;

  const normalize = (value = '') => value
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ').trim().toLowerCase();

  const emit = (event, detail = {}) => {
    return window.AVAnalytics?.legacy(event, detail) || false;
  };

  const repairDuplicateProductHeadings = (root = document) => {
    root.querySelectorAll?.('[data-av-pdp-v3]').forEach((pdp) => {
      const h1 = pdp.querySelector('h1');
      if (!h1) return;
      const title = normalize(h1.textContent);
      pdp.querySelectorAll('h2').forEach((heading) => {
        if (!title || normalize(heading.textContent) !== title || heading.closest('#looxReviews,[data-loox-aggregate]')) return;
        const replacement = document.createElement('div');
        [...heading.attributes].forEach(({ name, value }) => replacement.setAttribute(name, value));
        replacement.classList.add('av35-deduped-heading');
        replacement.innerHTML = heading.innerHTML;
        heading.replaceWith(replacement);
      });
    });
  };

  const ensureHeroFallback = (root = document) => {
    root.querySelectorAll?.('[data-av-product-stage]').forEach((stage) => {
      const slides = [...stage.querySelectorAll('[data-slide]')];
      if (!slides.length) return;
      const primary = slides.find((slide) => slide.classList.contains('media--active')) || slides[0];
      const image = primary.querySelector('img');
      if (!image) return;
      const recover = () => {
        if (image.naturalWidth > 1) return;
        const fallback = slides.find((slide) => slide !== primary && slide.querySelector('img'));
        if (!fallback) {
          stage.dataset.avMediaError = 'true';
          return;
        }
        primary.classList.remove('media--active');
        primary.classList.add('media--hidden');
        primary.setAttribute('aria-hidden', 'true');
        fallback.classList.remove('media--hidden');
        fallback.classList.add('media--active');
        fallback.removeAttribute('aria-hidden');
        stage.dataset.avMediaRecovered = 'true';
        emit('pdp_media_recovered', { product_handle: stage.closest('[data-product-handle]')?.dataset.productHandle || '' });
      };
      image.addEventListener('error', recover, { once: true });
      if (image.complete) recover();
    });
  };

  const syncGalleryAccessibility = (root = document) => {
    root.querySelectorAll?.('[data-slide]').forEach((slide) => {
      const sync = () => {
        const active = slide.classList.contains('media--active') && !slide.classList.contains('media--hidden');
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      };
      sync();
      if (slide.dataset.av35A11yBound) return;
      const observer = new MutationObserver(sync);
      observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
      slide.dataset.av35A11yBound = 'true';
    });
  };

  const enhanceQuantityLabels = (root = document) => {
    root.querySelectorAll?.('[data-product-handle], [data-av35-kit]').forEach((scope) => {
      const title = scope.querySelector('h1')?.textContent?.trim() || 'este produto';
      scope.querySelectorAll('quantity-input,.quantity').forEach((quantity) => {
        const buttons = quantity.querySelectorAll('button');
        buttons[0]?.setAttribute('aria-label', `Diminuir quantidade de ${title}`);
        buttons[1]?.setAttribute('aria-label', `Aumentar quantidade de ${title}`);
        const input = quantity.querySelector('input[type="number"],input[name="quantity"]');
        input?.setAttribute('aria-label', `Quantidade de ${title}`);
        if (input && !input.dataset.av35AnnounceBound) {
          input.dataset.av35AnnounceBound = 'true';
          input.addEventListener('change', () => {
            let live = document.getElementById('AV35QuantityStatus');
            if (!live) {
              live = document.createElement('p');
              live.id = 'AV35QuantityStatus';
              live.className = 'visually-hidden';
              live.setAttribute('role', 'status');
              live.setAttribute('aria-live', 'polite');
              document.body.append(live);
            }
            live.textContent = `${title}: quantidade ${input.value || 1}`;
          });
        }
      });
    });
  };

  const observeCTA = (root = document) => {
    if (!('IntersectionObserver' in window)) return;
    root.querySelectorAll?.('[data-av-pdp-v3]').forEach((pdp) => {
      if (pdp.dataset.av35CtaObserved) return;
      const cta = pdp.querySelector('button[name="add"]:not([disabled]),[data-av35-kit-submit]:not([disabled])');
      if (!cta) return;
      pdp.dataset.av35CtaObserved = 'true';
      new IntersectionObserver((entries, observer) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        document.documentElement.classList.add('av35-primary-cta-seen');
        observer.disconnect();
      }, { threshold: .2 }).observe(cta);
    });
  };

  const trackActions = (root = document) => {
    root.querySelectorAll?.('[data-av35-delivery]').forEach((module) => {
      if (module.dataset.av35Tracked) return;
      module.dataset.av35Tracked = 'true';
      module.addEventListener('toggle', () => {
        if (module.open) emit('pdp_delivery_opened');
      });
    });
    root.querySelectorAll?.('[data-av35-oos]').forEach((module) => {
      if (module.dataset.av35Tracked) return;
      module.dataset.av35Tracked = 'true';
      module.addEventListener('click', (event) => {
        if (event.target.closest('.av35-oos-shell__alternatives a')) emit('pdp_oos_alternative_click');
      });
      module.addEventListener('submit', () => emit('pdp_oos_notify_submit'));
    });
  };

  const init = (root = document) => {
    repairDuplicateProductHeadings(root);
    ensureHeroFallback(root);
    syncGalleryAccessibility(root);
    enhanceQuantityLabels(root);
    observeCTA(root);
    trackActions(root);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
